import React from "react";

/**
 * Species filter controls component
 * Handles search, category, and area filtering
 * 
 * @param {string} searchTerm - Search query
 * @param {Function} setSearchTerm - Search term setter
 * @param {string} selectedCategory - Selected category
 * @param {Function} setSelectedCategory - Category setter
 * @param {string} selectedArea - Selected area
 * @param {Function} handleAreaFilterChange - Area filter handler
 * @param {Array} categories - Available categories
 * @param {Array} areas - Available areas
 */
export default function SpeciesFilters({
    searchTerm,
    setSearchTerm,
    selectedCategory,
    setSelectedCategory,
    selectedArea,
    handleAreaFilterChange,
    categories,
    areas
}) {
    return (
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
            <div className="flex flex-col md:flex-row gap-4 items-stretch">
                {/* Search Bar */}
                <div className="flex-1">
                    <input
                        type="search"
                        placeholder="Sök efter art..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full px-4 py-3 rounded-lg border border-sage bg-white text-charcoal placeholder-charcoal/50 focus:outline-none focus:ring-2 focus:ring-forest focus:border-transparent"
                    />
                </div>

                {/* Category Filter */}
                <div className="md:w-56">
                    <select
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                        className="w-full px-4 py-3 pr-10 rounded-lg border border-sage bg-white text-charcoal focus:outline-none focus:ring-2 focus:ring-forest focus:border-transparent appearance-none bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20stroke%3D%22%236b7280%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20d%3D%22M6%208l4%204%204-4%22%2F%3E%3C%2Fsvg%3E')] bg-[length:1.5em] bg-[right_0.5rem_center] bg-no-repeat"
                    >
                        <option value="">Alla arter</option>
                        {categories.map((category) => (
                            <option key={category} value={category}>
                                {category}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Area Filter */}
                <div className="md:w-56">
                    <select
                        value={selectedArea}
                        onChange={handleAreaFilterChange}
                        className="w-full px-4 py-3 pr-10 rounded-lg border border-sage bg-white text-charcoal focus:outline-none focus:ring-2 focus:ring-forest focus:border-transparent appearance-none bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20stroke%3D%22%236b7280%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20d%3D%22M6%208l4%204%204-4%22%2F%3E%3C%2Fsvg%3E')] bg-[length:1.5em] bg-[right_0.5rem_center] bg-no-repeat"
                    >
                        <option value="">Alla områden</option>
                        {areas?.map((area) => (
                            <option key={area.name} value={area.name}>
                                {area.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
}
